module.exports = __webpack_public_path__ + "img/math_minus.6f852ecb.svg";